export const CONFIG_KEY_GET_CONFIG = 'CONFIG_KEY_GET_CONFIG';
export const CONFIG_KEY_POST_CONFIG = 'CONFIG_KEY_POST_CONFIG';
export const CONFIG_KEY_GET_IEXAM_CONFIG = 'CONFIG_KEY_GET_IEXAM_CONFIG';
export const CONFIG_KEY_UPDATE_IEXAM_CONFIG = 'CONFIG_KEY_UPDATE_IEXAM_CONFIG';
export const CONFIG_KEY_GET_COUNTRY_CODE = 'CONFIG_KEY_GET_COUNTRY_CODE';
export const CONFIG_KEY_GET_BIRTH_COUNTRY_CODE = 'CONFIG_KEY_GET_BIRTH_COUNTRY_CODE';
